const collator = new Intl.Collator('en', {
  numeric: true,
  sensitivity: 'base',
});

export const collatorSort = (a: string, b: string) => collator.compare(a, b);
